const routes = {
    LOGIN: "/login",
    LOGIN_WITH_SSO: "/loginWithSso",
    SELECT_SITE: "/select",
    CAPTURE_PHOTO: "/capture-photo",
    SHIFT_FOUND: "/shift-found"
}

export default routes
